import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SearchPipe } from '@pipes/search.pipe';
import { NumberOfKeysPipe } from '@pipes/number-of-keys.pipe';
import { JobSummary } from '@interfaces/jobs.interface';

@Component({
    selector: 'app-department-filter',
    templateUrl: './department-filter.component.html',
    styleUrls: ['./department-filter.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TranslatePipe, SearchPipe, NumberOfKeysPipe]
})
export class DepartmentFilterComponent {
  @Input() jobs: JobSummary[] = [];
  @Input() departments: string[] = [];
  @Output() departmentFilterChanged = new EventEmitter<string | undefined>();

  public filter: string | undefined;

  selectDepartment() {
    this.departmentFilterChanged.emit(this.filter);
  }

}
